import axios from 'axios';
import { getBaseUrlSolicitante, ensureProtocol } from '../config/backend';
import { refreshAccessToken, iniciarGestaoToken } from '../Solicitante/tokenManager';

async function validar(baseUrl, authHeader) {
    try {
        const res = await axios.get(baseUrl + '/token', { headers: { Authorization: authHeader } });
        return res.status;
    } catch (err) {
        const status = err?.response?.status;
        if (status === 401 || status === 403) return status;
        try {
            const res2 = await axios.get(baseUrl + '/api/token', { headers: { Authorization: authHeader } });
            return res2.status;
        } catch (err2) {
            return err2?.response?.status ?? 0;
        }
    }
}

async function verificandoTokenSolicitante(history) {
    const tipoSoft = localStorage.getItem('tipoSoft');
    if (tipoSoft !== 'SOLICITANTE') return;

    const baseUrl = getBaseUrlSolicitante() || ensureProtocol(localStorage.getItem('ipBackend') || '');
    if (!baseUrl && history) {
        history.push('/Solicitante');
        return;
    }

    const token = localStorage.getItem('token');
    if (!token || token.trim() === '') {
        if (history) history.push('/Solicitante');
        return;
    }

    const authHeader = token.startsWith('Bearer ') ? token : 'Bearer ' + token;
    const status = await validar(baseUrl, authHeader);

    if (status === 401 || status === 403) {

        const novo = await refreshAccessToken();
        if (!novo) {
            localStorage.setItem('token', '');
            if (history) history.push('/Solicitante');
            return;
        }
    }

    iniciarGestaoToken();
}

export default verificandoTokenSolicitante;
